/* =========================================================
 * OP Gallery — reusable product-style slideshow web component
 * <op-gallery> with .opg__slide children (each an <img> in a <figure>).
 * Builds prev/next arrows, dots and thumbnails; swipe via scroll-snap.
 * ========================================================= */
(function () {
  'use strict';

  class OpGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]') || this.querySelector('.opg__track');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('.opg__slide'));
      if (this.slides.length <= 1) { this.setAttribute('data-single', ''); return; }

      this._buildControls();
      this._bind();
      this._sync();
    }

    _buildControls() {
      var stage = this.querySelector('.opg__stage') || this.track.parentNode;

      // Arrows
      this.prev = document.createElement('button');
      this.prev.type = 'button'; this.prev.className = 'opg__arrow opg__arrow--prev';
      this.prev.setAttribute('aria-label', 'Previous image');
      this.prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
      this.next = document.createElement('button');
      this.next.type = 'button'; this.next.className = 'opg__arrow opg__arrow--next';
      this.next.setAttribute('aria-label', 'Next image');
      this.next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
      stage.appendChild(this.prev); stage.appendChild(this.next);

      // Dots
      this.dotsWrap = document.createElement('div');
      this.dotsWrap.className = 'opg__dots';
      this.dots = this.slides.map(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'opg__dot'; d.setAttribute('aria-label', 'Go to image ' + (i + 1));
        d.addEventListener('click', this._goTo.bind(this, i));
        this.dotsWrap.appendChild(d);
        return d;
      }.bind(this));
      stage.appendChild(this.dotsWrap);

      // Thumbnails
      this.thumbsWrap = this.querySelector('[data-thumbs]');
      if (!this.thumbsWrap) {
        this.thumbsWrap = document.createElement('div');
        this.thumbsWrap.className = 'opg__thumbs';
        this.appendChild(this.thumbsWrap);
      }
      this.thumbsWrap.innerHTML = '';
      this.thumbs = this.slides.map(function (s, i) {
        var img = s.querySelector('img');
        var t = document.createElement('button');
        t.type = 'button'; t.className = 'opg__thumb'; t.setAttribute('aria-label', 'Image ' + (i + 1));
        t.innerHTML = '<img src="' + (img ? img.getAttribute('src') : '') + '" alt="" loading="lazy">';
        t.addEventListener('click', this._goTo.bind(this, i));
        this.thumbsWrap.appendChild(t);
        return t;
      }.bind(this));
    }

    _bind() {
      this.prev.addEventListener('click', function () { this._goTo(Math.max(0, this._current() - 1)); }.bind(this));
      this.next.addEventListener('click', function () { this._goTo(Math.min(this.slides.length - 1, this._current() + 1)); }.bind(this));
      var raf = null;
      this.track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; this._sync(); }.bind(this));
      }.bind(this));
    }

    _current() {
      var mid = this.track.scrollLeft + this.track.clientWidth / 2, idx = 0;
      this.slides.forEach(function (s, i) { if (s.offsetLeft - this.track.offsetLeft <= mid) idx = i; }, this);
      return idx;
    }

    _goTo(i) {
      var slide = this.slides[i]; if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }

    _sync() {
      var i = this._current();
      if (this.dots) this.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (this.thumbs) this.thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (this.prev) this.prev.hidden = i === 0;
      if (this.next) this.next.hidden = i === this.slides.length - 1;
    }
  }

  if (!window.customElements.get('op-gallery')) {
    window.customElements.define('op-gallery', OpGallery);
  }
})();
